import { MainRouteStore } from "common/stores";

class AdministrationRouteStore extends MainRouteStore {
    constructor(rootStore) {
        super(rootStore);
    }
}

export default AdministrationRouteStore;
